"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mcpAllowedScopes = void 0;
const mcp_allowed_scopes_json_1 = __importDefault(require("./mcp-allowed-scopes.json"));
exports.mcpAllowedScopes = mcp_allowed_scopes_json_1.default;
//# sourceMappingURL=index.js.map